import { render, staticRenderFns } from "./DocumentUploadForm.vue?vue&type=template&id=6d63ce18&scoped=true"
import script from "./DocumentUploadForm.vue?vue&type=script&lang=js"
export * from "./DocumentUploadForm.vue?vue&type=script&lang=js"
import style0 from "./DocumentUploadForm.vue?vue&type=style&index=0&id=6d63ce18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d63ce18",
  null
  
)

export default component.exports